import { render, staticRenderFns } from "./BasePopup.vue?vue&type=template&id=03fe864d"
import script from "./BasePopup.vue?vue&type=script&lang=ts"
export * from "./BasePopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports